import { startTransition, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { FILTER_SESSION_KEYS } from '../constants/filterSession';
export { FILTER_SESSION_KEYS } from '../constants/filterSession';

/** URL history wins; a fresh sidebar visit restores this tab's last filters. */
export function useRememberedSearchParams(key: typeof FILTER_SESSION_KEYS[number]) {
  const [params, setParams] = useSearchParams();
  const [restore, setRestore] = useState<string | null>(() => {
    if (params.toString()) return null;
    try { return sessionStorage.getItem(key) || null; } catch { return null; }
  });
  const [initialParams] = useState(() => new URLSearchParams(restore ?? ''));

  useEffect(() => {
    if (restore !== null) {
      startTransition(() => {
        setParams(new URLSearchParams(restore), { replace: true });
        setRestore(null);
      });
      return;
    }
    try { sessionStorage.setItem(key, params.toString()); } catch { /* URL still works. */ }
  }, [key, params, restore, setParams]);

  return [restore !== null ? initialParams : params, setParams] as const;
}
